export enum AppSubdomain {
    accounts = 'account-settings',
    devCenter = 'devcenter',
    earn = 'earn',
    profiles = 'profiles',
    tcAcademy = 'academy',
    onboarding = 'onboarding',
    work = 'work',
    talentSearch = 'talent-search',
    wallet = 'wallet',
    walletAdmin = 'wallet-admin',
    copilots = 'copilots',
    admin = 'system-admin',
    review = 'review',
    calendar = 'calendar',
}

export enum ToolTitle {
    accounts = 'Account Settings',
    devCenter = 'Dev Center',
    earn = 'Opportunity Feed',
    profiles = 'Profiles',
    tcAcademy = 'Topcoder Academy',
    selfService = 'Self Service Challenges',
    onboarding = ' ',
    talentSearch = 'Expert Talent',
    wallet = 'Wallet',
    walletAdmin = 'Wallet Admin',
    copilots = 'Copilots',
    admin = 'Admin',
    review = 'Review',
    calendar = 'Calendar',
}

export const PageSubheaderPortalId: string = 'page-subheader-portal-el'
